export default __webpack_public_path__ + "static/media/BookShelf.77897937ac8343a20cd81946581e9037.webp";